"use client";

import { LMSExplanation } from "./_components/lms_explanation";

export default function LMSIntegrations() {
	return (
		<main className="my-20 flex flex-col items-center justify-center sm:mb-40" role="main" aria-label="LMS Integrations">
			<div className="w-full max-w-(--breakpoint-lg) px-4">
				<LMSExplanation />
			</div>
		</main>
	);
}
